const skills = [
  {
    id: 1,
    icon: "fas fa-code fa-stack-1x fa-inverse icon",
    name: "Web Development",
    content: "Fast, responsive and engaging apps that bring your ideas to life."
  },
  {
    id: 2,
    icon: "fas fa-mobile-alt fa-stack-1x fa-inverse icon",
    name: "Mobile Application Development",
    content:
      "Cross-platform apps built with efficiency and speed for Android and iOS."
  },
  {
    id: 3,
    icon: "fas fa-cogs fa-stack-1x fa-inverse icon",
    name: "API Development",
    content:
      "REST APIs that are tailored to your needs and follow the best practices in performance and security"
  },
  {
    id: 4,
    icon: "fas fa-link fa-stack-1x fa-inverse icon",
    name: "Third-party API Integration",
    content:
      "Integration with any third-party API of your choice. Extend the functionality of your apps with the least amount of effort."
  },
  {
    id: 5,
    icon: "fas fa-database fa-stack-1x fa-inverse icon",
    name: "Database Design",
    content:
      "Proper Database design for effective Web & Mobile development, always aiming for performance, scale and stability."
  },
  {
    id: 6,
    icon: "fas fa-cloud fa-stack-1x fa-inverse icon",
    name: "Cloud Integration",
    content:
      "Deployment and maintenance of your apps in a wide range of Cloud Services, from fully managed to highly customizable VPS."
  }
];

export default skills;
